<div class="space-y-3xl md:space-y-10">
  @for (section of content; track section; let last = $last) {
    @if (section.__type === 'HowItWorksSection') {
      <bgo-how-it-works-section
        [section]="section"
        (mainCallToActionClick)="howItWorksCtaClicked.emit()"
        class="h-layout"
        [class.pb-4xl]="last"
      ></bgo-how-it-works-section>
    }
    @if (section.__type === 'IndustrySection') {
      <bgo-industry-section [industrySection]="section" class="h-layout" [class.pb-4xl]="last"></bgo-industry-section>
    }
    @if (section.__type === 'InspirationSection') {
      <bgo-inspiration-section
        [inspirationSection]="section"
        class="h-layout"
        [class.pb-4xl]="last"
      ></bgo-inspiration-section>
    }
    @if (section.__type === 'PartnerSection') {
      <cft-partners [section]="section" class="h-layout" [class.pb-4xl]="last"></cft-partners>
    }
    @if (section.__type === 'PromotionalBannerSection') {
      <bgo-promotional-banner-section
        [section]="section"
        class="h-layout"
        [class.pb-4xl]="last"
      ></bgo-promotional-banner-section>
    }
    @if (section.__type === 'ReviewSection') {
      <bgo-reviews-section
        [reviewSection]="section"
        (buttonClicked)="reviewCtaClicked.emit()"
        class="h-layout"
        [class.pb-4xl]="last"
      ></bgo-reviews-section>
    }
    @if (section.__type === 'ServicesSection') {
      <bgo-services-section
        [servicesSection]="section"
        itemsElevation="flat"
        [itemsSeparator]="false"
        itemsCallToActionAppearance="hidden"
        class="h-layout"
        [class.pb-4xl]="last"
      ></bgo-services-section>
    }
    @if (section.__type === 'SupportSection') {
      <bgo-support-section [supportSection]="section"></bgo-support-section>
    }
    @if (section.__type === 'KnowledgeSection') {
      <bgo-knowledge-section [knowledgeSection]="section" class="h-layout"></bgo-knowledge-section>
    }
    @if (section.__type === 'PresentationSection') {
      <bgo-presentation-section
        [title]="section.title"
        [plot]="section.plot"
        [items]="section.items"
      ></bgo-presentation-section>
    }
  }
</div>
